module.exports = __webpack_public_path__ + "static/media/123-BeschreibungWhite.025e79c3.jpg";